import { DOCUMENT } from '@angular/common';
import { Inject }  from '@angular/core';
import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAccordionDefaultOpenIcons]'
})
export class AccordionDefaultOpenIconsDirective {

  constructor(
    @Inject(DOCUMENT) document,
    private el: ElementRef,
    private renderer: Renderer2
  ) { }
  isClose = true;

  @HostListener('click', ['$event']) accordion($event) {
    this.isClose = !this.isClose;
    let cfaicon = this.el.nativeElement.querySelector('h4');
    let faicon = this.el.nativeElement.querySelector('.icon-info');
    if (this.isClose) {
      this.renderer.removeClass(faicon, 'fa-arrow-down');
      this.renderer.addClass(faicon, 'fa-arrow-up');
      this.renderer.removeClass(cfaicon, 'accordion-down');
      this.renderer.addClass(cfaicon, 'accordion-up');
    } else {
      this.renderer.removeClass(faicon, 'fa-arrow-up');
      this.renderer.addClass(faicon, 'fa-arrow-down');
      this.renderer.removeClass(cfaicon, 'accordion-up');
      this.renderer.addClass(cfaicon, 'accordion-down');
    }
  }
}


